<template>
  <section class="forHome">
    <Grid class="intro-grid">
      <div class="htd">
        <div>
          Human
          <br />Tech
          <br />Design
        </div>
      </div>
      <div class="intro txt">
        <p>
          <strong>
            Hi, I’m Mathias.
            <br />I am a design strategist.
          </strong>
          <br />
          <br />I work for brave people and organizations that are challenged by
          wicked problems.
        </p>
        <p>
          I combine the crafts of design, coding and management to
          create digital transformation and calm technology.
        </p>
        <p>
          I’m based in Hamburg,
          <br />Germany.
        </p>
      </div>
    </Grid>
  </section>
</template>
<script>
import Grid from "./Grid.vue";
export default {
  name: "Intro",
  components: {
    Grid
  }
};
</script>
<style scoped>
@media only screen and (max-width: 576px) {
  .htd {
    min-height: calc(var(--vh) * 100 - 10 * var(--LINE-HEIGHT));
    font-family: "Urby-Regular", Arial, Helvetica, sans-serif;
    width: calc(var(--COLUMN-SIZE) * 4);
    line-height: 60px;
    font-size: 70px;
    letter-spacing: 3.5px;
    display: flex;
    justify-content: right;
    flex-direction: row;
  }

  .htd div {
    margin-top: calc(var(--LINE-HEIGHT) * 0);
    align-self: center;
    width: 100%;
  }
  .intro {
    padding-top: 0;
    padding-left: 0;
    padding-right: 0;
    width: calc(var(--COLUMN-SIZE) * 5);
  }
}
@media only screen and (min-width: 576px) and (max-width: 767px) {
  .htd {
    padding-top: calc(2 * var(--LINE-HEIGHT));
    padding-bottom: calc(1 * var(--LINE-HEIGHT));
    font-family: "Urby-Regular", Arial, Helvetica, sans-serif;
    width: calc(var(--COLUMN-SIZE) * 4);
    line-height: 65px;
    font-size: 80px;
    display: flex;
    justify-content: left;
  }

  .htd div {
    margin-left: -6px;
  }

  .intro {
    /* padding-left: calc( var(--COLUMN-SIZE) * 2 ); */
    padding-right: calc(var(--COLUMN-SIZE) * 0.5);
    align-self: flex-end;
    padding-left: calc(var(--COLUMN-SIZE) * 2);
    width: calc(var(--COLUMN-SIZE) * 1.5);
  }
}
@media only screen and (min-width: 767px) and (max-width: 992px) {
  .htd {
    min-height: calc(100 * var(--vh) - 13 * var(--LINE-HEIGHT));
    padding-top: calc(5 * var(--LINE-HEIGHT));
    font-family: "Urby-Regular", Arial, Helvetica, sans-serif;
    width: calc(var(--COLUMN-SIZE) * 4);
    line-height: 75px;
    font-size: 92px;
    display: flex;
    justify-content: left;
  }

  .htd div {
    margin-left: -8px;
  }

  .intro {
    padding-top: calc(12 * var(--LINE-HEIGHT));
    min-height: calc(100 * var(--vh) - 20 * var(--LINE-HEIGHT));
    padding-left: 0;
    padding-right: var(--COLUMN-SIZE);
    width: calc(var(--COLUMN-SIZE) * 3);
  }
}
@media only screen and (min-width: 992px) {
  .intro-grid {
    /* min-height: calc(100vh - 10 * var(--LINE-HEIGHT)); */
  }
  .htd {
    min-height: calc(100vh - 16 * var(--LINE-HEIGHT));
    padding-top: calc(5 * var(--LINE-HEIGHT));
    font-family: "Urby-Regular", Arial, Helvetica, sans-serif;
    width: calc(var(--COLUMN-SIZE) * 3);
    line-height: 75px;
    font-size: 92px;
    display: flex;
    justify-content: left;
    letter-spacing: 3.5px;
  }
  .intro {
    min-height: calc(100vh - 13 * var(--LINE-HEIGHT));
    padding-top: calc(12 * var(--LINE-HEIGHT));
    align-self: center;
    padding-left: calc(var(--COLUMN-SIZE) * 1);
    padding-right: calc(var(--COLUMN-SIZE) * 2);
    width: calc(var(--COLUMN-SIZE) * 2);
  }
}

.htd div {
  text-align: right;
}

.intro p {
  padding-bottom: calc(var(--LINE-HEIGHT) * 1);
}
</style>



// WEBPACK FOOTER //
// src/components/Section.Intro.vue